var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConffetti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Popper Confetti"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#35cfbe",
    d: "M33.42 29.8a1 1 0 0 1-.7-1.71 11.66 11.66 0 0 0 0-16.47 1 1 0 0 1 0-1.42 1 1 0 0 1 1.41 0 13.68 13.68 0 0 1 0 19.31 1 1 0 0 1-.71.29z",
    opacity: 1,
    "data-original": "#35cfbe"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#feba4e",
    d: "M82.41 60.89a1 1 0 0 1-.71-.29 11.65 11.65 0 0 0-16.48 0 1 1 0 0 1-1.41 0 1 1 0 0 1 0-1.42 13.65 13.65 0 0 1 19.3 0 1 1 0 0 1-.7 1.71z",
    opacity: 1,
    "data-original": "#feba4e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4362a5",
    d: "M48.67 45a1 1 0 0 1-.67-1.67 5.85 5.85 0 0 1 4.6-1.59 3.75 3.75 0 0 0 3.18-1c2.13-2.13-.31-4.88 2.59-7.78a5.75 5.75 0 0 1 4.6-1.59 3.62 3.62 0 0 0 4.19-4.19 5.75 5.75 0 0 1 1.59-4.6c2.91-2.91 5.64-.45 7.79-2.6a1 1 0 0 1 1.42 0 1 1 0 0 1 0 1.41c-2.91 2.91-5.63.44-7.79 2.6a3.83 3.83 0 0 0-1 3.19 5.56 5.56 0 0 1-6.19 6.19 3.82 3.82 0 0 0-3.18 1c-2.14 2.14.3 4.89-2.59 7.78s-5.65.46-7.79 2.6a1 1 0 0 1-.75.25z",
    opacity: 1,
    "data-original": "#4362a5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f74367",
    d: "M59.8 14a1 1 0 0 1-1-1c.14-2.66 2-2.81 2.07-4.58s-1.72-2.12-1.59-4.77a1 1 0 0 1 2 .11c-.09 1.73 1.72 2.1 1.59 4.74s-2 2.8-2.07 4.58a1 1 0 0 1-1 .92z",
    opacity: 1,
    "data-original": "#f74367"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3499ff",
    d: "M69.31 80.15a4.3 4.3 0 0 1-3.16-1.29 2.45 2.45 0 0 0-1.69-.8 1 1 0 0 1 .11-2 4.3 4.3 0 0 1 2.89 1.28 2.47 2.47 0 0 0 3.44.18 4.32 4.32 0 0 1 3-1 1 1 0 0 1 1 1 1 1 0 0 1-1 1c-1.79-.05-2.18 1.63-4.59 1.63z",
    opacity: 1,
    "data-original": "#3499ff",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.43,
    cy: 19.85,
    r: 3.7,
    fill: "#feba4e",
    opacity: 1,
    "data-original": "#feba4e",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.56,
    cy: 46.51,
    r: 3.7,
    fill: "#35cfbe",
    opacity: 1,
    "data-original": "#35cfbe"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#93bcff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95 28.48h-1.89a1 1 0 0 1 0-2H95a1 1 0 0 1 0 2zM85.75 28.48h-1.9a1 1 0 0 1 0-2h1.9a1 1 0 0 1 0 2zM89.43 24.8a1 1 0 0 1-1-1v-1.89a1 1 0 1 1 2 0v1.89a1 1 0 0 1-1 1zM89.43 34.06a1 1 0 0 1-1-1v-1.9a1 1 0 1 1 2 0v1.9a1 1 0 0 1-1 1zM19.15 24.8c-.55 0-.68-.27-2-1.64a1 1 0 0 1 0-1.41 1 1 0 0 1 1.41 0l1.34 1.34a1 1 0 0 1-.75 1.71zM12.61 18.25c-.55 0-.69-.27-2-1.63A1 1 0 1 1 12 15.21l1.33 1.33a1 1 0 0 1-.72 1.71zM17.81 18.25a1 1 0 0 1-.7-1.71l1.33-1.33a1 1 0 0 1 1.42 1.41c-1.45 1.45-1.52 1.63-2.05 1.63zM11.27 24.8a1 1 0 0 1-.71-1.71l1.34-1.34a1 1 0 0 1 1.41 0 1 1 0 0 1 0 1.41c-1.45 1.45-1.52 1.64-2.04 1.64z",
    fill: "#93bcff",
    opacity: 1,
    "data-original": "#93bcff"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#3499ff",
    d: "M34.68 44.87a1 1 0 0 1-.68-1.71l10.21-10.24a1 1 0 0 1 1.42 0 1 1 0 0 1 0 1.41L35.38 44.57a1 1 0 0 1-.7.3z",
    opacity: 1,
    "data-original": "#3499ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#345dc8",
    d: "M39.48 37.65 34 43.16a1 1 0 0 0 .71 1.71 1 1 0 0 0 .7-.3l5.51-5.51a1 1 0 0 0-1.41-1.41z",
    opacity: 1,
    "data-original": "#345dc8",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f74367",
    d: "M50.92 60.87a1 1 0 0 1-.71-1.7l20.34-20.35a12.5 12.5 0 0 1 9.11-3.67 1 1 0 0 1 0 2A10.44 10.44 0 0 0 72 40.24L51.63 60.58a1 1 0 0 1-.71.29z",
    opacity: 1,
    "data-original": "#f74367"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c52f67",
    d: "M61.75 49.31a1 1 0 0 0-1.53-.16l-10 10a1 1 0 0 0 .71 1.7 1 1 0 0 0 .71-.29l10-10a1 1 0 0 0 .11-1.25z",
    opacity: 1,
    "data-original": "#c52f67"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fe924e",
    d: "M59.6 70.6c-.4.17-18.22 7.25-27.93 11.09L5.57 92.07a3.33 3.33 0 0 1-4.33-4.33c.07-.17 19.47-49.2 21.48-54a2.84 2.84 0 0 1 4.65-1l33.18 33.19a2.85 2.85 0 0 1-.95 4.67z",
    opacity: 1,
    "data-original": "#fe924e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#feba4e",
    d: "m45.24 70.23-32.3 13a2 2 0 0 1-2.59-2.62C21 53.57 8.73 84.69 23.19 47.89a1.69 1.69 0 0 1 2.81-.58L45.81 67.4a1.74 1.74 0 0 1-.57 2.83z",
    opacity: 1,
    "data-original": "#feba4e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#345dc8",
    d: "m49.24 74.72-8.52 3.39-25.51-25.52 3.39-8.51z",
    opacity: 1,
    "data-original": "#345dc8",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#434487",
    d: "m31.67 81.69-8.51 3.39L8.23 70.16l3.39-8.52z",
    opacity: 1,
    "data-original": "#434487"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3499ff",
    d: "M44.89 70.37c-7 2.83-5.15 2.09-8.49 3.42L19.62 57c.75-1.92 1.39-3.53 2.84-7.26l.5-1.29z",
    opacity: 1,
    "data-original": "#3499ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4362a5",
    d: "m27.39 77.41-8.48 3.42-6.21-6.2 3.36-8.55z",
    opacity: 1,
    "data-original": "#4362a5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fef68a",
    d: "M25.34 41.93a1 1 0 0 1-1.41 0l-3.2-3.2.77-1.95c.18 0 .58.47 3.84 3.73a1 1 0 0 1 0 1.42zM33.49 51.07a1 1 0 0 1-.71-.29l-3.51-3.51a1 1 0 0 1 1.42-1.42l3.5 3.51a1 1 0 0 1-.7 1.71zM42.33 59.92a1 1 0 0 1-.7-.3l-3.51-3.5a1 1 0 1 1 1.42-1.42L43 58.21a1 1 0 0 1-.67 1.71zM51.18 68.77a1 1 0 0 1-.7-.3L47 65a1 1 0 0 1 0-1.42 1 1 0 0 1 1.41 0l3.51 3.51a1 1 0 0 1-.74 1.68z",
    opacity: 1,
    "data-original": "#fef68a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M24.08 68.81a1 1 0 0 1-1.45 0l-3.16-3.16a1 1 0 0 1 1.45-1.45l3.16 3.16a1 1 0 0 1 0 1.45zM28 58.76a2.47 2.47 0 0 1-3.49 0l-1.12-1.11a2.47 2.47 0 0 1 3.5-3.5L28 55.27a2.46 2.46 0 0 1 0 3.49z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43cbff",
    d: "m32.252 63.612 2.92-2.92 6.271 6.272-2.92 2.92a1.42 1.42 0 0 1-2.007 0l-4.242-4.243a1.42 1.42 0 0 1-.022-2.029z",
    opacity: 1,
    "data-original": "#43cbff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fed872",
    d: "M59.6 70.6c-.18.08 1.69 1.86-36.93-36.76a2.84 2.84 0 0 1 4.7-1.08l33.18 33.17a2.85 2.85 0 0 1-.95 4.67z",
    opacity: 1,
    "data-original": "#fed872"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConffetti);
export default __webpack_public_path__ + "static/media/conffetti.25d33feb09dffd2abe7bba080199f921.svg";
export { ForwardRef as ReactComponent };